import React from 'react'
import { apiConfig } from '../../config/app'
import styles from './Header.module.css'

// The B2B PDF is streamed by the backend proxy at `<api-origin>/b2b.pdf`
// (see B2bPdfProxyResource on the server). `apiConfig.baseUrl` points at
// `<api-origin>/api/ecom`, so we strip the path and append `/b2b.pdf`.
const B2B_PDF_URL = (() => {
  try {
    return `${new URL(apiConfig.baseUrl).origin}/b2b.pdf`
  } catch {
    return '/b2b.pdf'
  }
})()

const B2BButton: React.FC = () => (
  <a
    href={B2B_PDF_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={styles.b2bBtn}
    aria-label="Open B2B PDF"
  >
    <span className={styles.b2bText}>B2B</span>
  </a>
)

export default B2BButton
